<script setup>
import { reactive, ref, onMounted } from "vue";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Spinner } from "../../src/loandig";
import Swal from 'sweetalert2'
const props = defineProps({
   title: String,
   key: {
      type: Number,
      default: 26,
   },
   url: String,
   tour: String
});
const GetTours = ref([])
const getKey = ref(props.key)
const getUrl = ref(props.url)
const getTourName = ref(props.tour)
const PearScript = ref(null);

onMounted(() => {
   const dates = flatpickr("#myID", {
      minDate: "today",
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
   });
   const dates2 = flatpickr("#myID3", {
      minDate: "today",
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
   });
   console.log(dates)
   const loandig = new Spinner({
      selector: ".loandig",
      width: 25,
      height: 25,
      text: "loandig..",
      color: "#d7b672",
      background: "#fff",
   });
   window.loandig = loandig;
   const Spins = new Spinner({
      selector: ".spinss",
      width: 25,
      height: 25,
      text: "loandig..",
      color: "#d7b672",
      background: "#fff",
   });
   window.Spins = Spins;
   PearScript.value = PEARSCRIPTC;
   console.log(PearScript.value.ajax_url)
});

const initialState = () => ({
      tours: getKey.value,
      tourName: getTourName.value,
      startDate: '',
      opcionalDate: '',
      fullName: '',
      phone: '',
      email: '',
      travellers: [
        {
          name: '',
          passport: '',
          nationality: '',
          gender: '',
          birthDate: '',
          food: '',
        }
      ],
      // extras
      huaynapichu: false,
      hotel: '',
      desHotel: '',
      message: '',
    });
const DataTravel = reactive(initialState());
const resetDataTravel = () => {
      Object.assign(DataTravel, initialState());
    };
// get-tours api
const tours = async () => {
   try {
      let categories = await fetch("https://glampingperutreks.com/wp-json/wp/v2/categories?exclude=11");
      // "https://www.winayperuadventure.com/wp-json/wp/v2/categories?exclude=11"
      let category = await categories.json();
      let getpost = await fetch(`https://glampingperutreks.com/wp-json/wp/v2/posts?per_page=100`);
      let post = await getpost.json();
      GetTours.value = { category, post };
   } catch (error) {
      console.log(error);
   }

}
tours()
// change tours
const SelectTours = (event) => {
   for (let item in GetTours.value.category) {
      // if (GetTours.value[item].Tours.post) {
      GetTours.value.post.forEach((element) => {
         if (element.id == DataTravel.tours) {
            // console.log(element)
            // Price.value = parseInt(element.acf.price) * DB.travellers.length;
            // PriceStatic.value = parseInt(element.acf.price);
            DataTravel.tourName = element.title.rendered;
         }
      });
      // }
   }
};
const addPass = () => {
   loandig.active()
   setTimeout(() => {
      DataTravel.travellers.push({
         name: '',
         passport: '',
         nationality: '',
         gender: '',
         birthDate: '',
         food: '',
      });
      // Price.value = PriceStatic.value * DB.travellers.length;
      loandig.hide()
   }, 2000);
};
//  REMOVE PASS TRAVELLERS
const removePass = (index) => {
   if (DataTravel.travellers.length > 1) {
      if (confirm("Are you sure you want to remove")) {
         loandig.active('deleting')
         setTimeout(() => {
            DataTravel.travellers.splice(index, 1);

            loandig.hide()
         }, 2000);
      }
   }
};
const submit = async () => {
   Spins.active();
   const DB = new FormData();
   DB.append('pear_hook', PearScript.pear_hook);
   DB.append('action', PearScript.action_contact);
   DB.append('data', JSON.stringify(DataTravel))
   try {
      let res = await fetch(PearScript.ajax_url,{
         method: "POST",
         body: DB,
      })
      let data = await (res.ok ? res.json() : (Spins.hide(), Promise.reject(new Error('La solicitud no fue exitosa'))));

      if (data.success) {
         Spins.hide()
         resetDataTravel()
         Swal.fire({
            title: data.data.title,
            text: data.data.message,
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
         });
      } else if (data.data.status == 500) {
         Spins.hide()
         Swal.fire({
            title: data.data.title,
            text: data.data.message,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
         });
      } else {
         Spins.hide()
         resetDataTravel()
         Swal.fire({
            title: data.data,
            text: null,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Update',
            showCloseButton: true,
            confirmButtonColor: '#000', // Cambia esto al color que desees
            customClass: {
               confirmButton: ' btn-sm rounded-0 shadow-0' // Agrega aquí la clase personalizada que quieras
            }
         }).then((result) => {
            if (result.isConfirmed) {
               location.reload(); // Esto recarga la página
            }
         });

      }


   } catch (error) {
      console.log(error)
      Spins.hide()
   }
};
</script>
<template>
   <div class="container">
      <h3 class="text-center letter-spacing-2 fw-bold text-uppercase">
         {{ title }}
      </h3>
      <div class="border p-5">
         <form action="#" @submit.prevent="submit">
            <div class="row justify-content-center">
               <div class="col-md-12">
                  <div class="div mb-3 ">
                     <label for="tours" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Which
                        Tour/Trek
                        are
                        you booking?</label>
                     <select class="form-select rounded-0 fs-small letter-spacing-1 fw-500" v-model="DataTravel.tours"
                        @click="SelectTours" name="tour" aria-label="Default select example" required="">
                        <optgroup v-for="(cat, index) in GetTours.category" :value="cat.name" :key="index"
                           :label="cat.name">
                           <template v-for="(post, index) in GetTours.post" :key="index">
                              <option v-if="cat.id == post.categories[0]" :value="post.id">
                                 <span v-html="post.title.rendered"></span>
                              </option>
                           </template>
                        </optgroup>
                     </select>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="div mb-2">
                     <label for="traveldate" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">
                        Departure
                        date</label>
                     <input type="text" v-model="DataTravel.startDate"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500" id="myID" required>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="div mb-2">
                     <label for="opcionaltravel"
                        class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Optional
                        Tour/Trek Date</label>
                     <input type="text" v-model="DataTravel.opcionalDate" id="myID3"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500">
                  </div>
               </div>
               <!-- contact -->
               <div class="col-md-12">
                  <div class="border-top mt-3">
                     <span class=" ms-4 mt-2 d-block letter-spacing-1 fs-small fw-500 text-uppercase ">Contact Personal
                        Information</span>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="div mb-2">
                     <label for="fullName" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Full
                        Name</label>
                     <input v-model="DataTravel.fullName" type="text"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="div mb-2">
                     <label for="opcionaltravel"
                        class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">You Phone
                        Number <small class="text-secondary fw-500 text-lowercase">(Optional)</small></label>
                     <input type="text" v-model="DataTravel.phone"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500">
                  </div>
               </div>
               <div class="col-md-12">
                  <div class="div mb-2">
                     <label for="fullName" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">E-mail
                        <small class="text-secondary fw-500 text-lowercase">(email address of the person for the main
                           Point Of
                           Contact
                           (POC) in your group)</small> </label>
                     <input type="email" v-model="DataTravel.email"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                  </div>
               </div>
               <!-- Passenger information -->
               <div class="col-md-12">
                  <div class="border-top mt-3">
                     <span class=" ms-4 mt-2 d-block letter-spacing-1 fs-small fw-500 text-uppercase ">Passenger
                        information</span>
                  </div>
               </div>
               <div class="col-md-12">
                  <div class="border p-2 position-relative">
                     <div class="row" v-for="(pass, index) in DataTravel.travellers" :key="index">
                        <div class="col-md-12">
                           <div class="d-flex px-3 mt-2 justify-content-between">
                              <h4 class="letter-spacing-2 fs-6">Traveller {{ index + 1 }}</h4>
                              <span type="button" @click="removePass(index)" class="fw-bold text-danger"
                                 title="Delete"><i class="bi bi-x-lg"></i></span>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Full
                                 Name</label>
                              <input type="text" v-model="pass.name"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Passport
                                 Number</label>
                              <input type="text" v-model="pass.passport"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Date of
                                 Birth</label>
                              <input type="text" v-model="pass.birthDate"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Nationality</label>
                              <input type="text" v-model="pass.nationality"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Gender</label>
                              <input type="text" v-model="pass.gender"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500" required>
                           </div>
                        </div>
                        <div class="col-md-4">
                           <div class="div mb-2">
                              <label for="fullName"
                                 class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Food
                                 Restriccion</label>
                              <input type="text" v-model="pass.food"
                                 class="form-control rounded-0 fs-small letter-spacing-1 fw-500">
                           </div>
                        </div>
                     </div>
                     <div class="text-end">
                        <button @click="addPass" type="button"
                           class="btn btn-small btn-primary  rounded-0 fs-small letter-spacing-1 fw-500 px-4 loandig">Add</button>
                     </div>
                  </div>
               </div>
               <!-- Extras -->
               <div class="col-md-12">
                  <div class="border-top mt-3">
                     <span class=" ms-4 mt-2 mb-3 d-block letter-spacing-1 fs-small fw-500 text-uppercase ">Upgrades and
                        extras</span>
                  </div>
                  <div class="div mb-2">
                     <label for="fullName" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Extra
                        Hikes (Only one hike is possible per day because of lack of time)</label>
                     <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="Yes" v-model="DataTravel.huaynapichu"
                           id="flexCheckDefault">
                        <label class="form-check-label fs-small" for="flexCheckDefault">
                           Huayna Picchu Mountain hike($85 per person)
                        </label>
                     </div>
                  </div>
                  <div class="div mb-2">
                     <label for="fullName" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">HOTEL
                        QUALITY</label>
                     <div class="form-check">
                        <input class="form-check-input" v-model="DataTravel.hotel" type="radio" name="hotel" id="hotel5"
                           value="5 star">
                        <label class="form-check-label fs-small" for="hotel5">
                           Luxury (
                           <small class="text-primary">
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                           </small>)
                        </label>
                     </div>
                     <div class="form-check">
                        <input class="form-check-input" type="radio" name="hotel" id="hotel4" v-model="DataTravel.hotel"
                           value="4 star">
                        <label class="form-check-label fs-small" for="hotel4">
                           Superior (
                           <small class="text-primary">
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                           </small>)
                        </label>
                     </div>
                     <div class="form-check">
                        <input class="form-check-input" type="radio" name="hotel" id="hotel3" v-model="DataTravel.hotel"
                           value="3 star">
                        <label class="form-check-label fs-small" for="hotel3">
                           Best Value (
                           <small class="text-primary">
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                              <i class="bi bi-star-fill ms-1"></i>
                           </small>)
                        </label>
                     </div>
                     <div>
                        <label for="sds" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">additional
                           information
                           about hotel</label>
                        <textarea v-model="DataTravel.desHotel" name="adicionalhotel" id="sds" cols="30" rows="3"
                           class="form-control rounded-0 fs-small letter-spacing-1 fw-500"></textarea>
                     </div>
                  </div>
               </div>
               <!-- desctiption -->
               <div class="col-md-12">
                  <div class="div mb-2 mt-3 ">
                     <label for="fullName" class="form-label letter-spacing-1 fs-small fw-bold text-uppercase ">Please
                        add any
                        additional information you think Glamping Peru Treks needs to know for your booking.</label>
                     <textarea name="message" v-model="DataTravel.message"
                        class="form-control rounded-0 fs-small letter-spacing-1 fw-500" id="" cols="30"
                        rows="3"></textarea>
                  </div>
               </div>
            </div>
            <div class="text-center">
               <button type="submit"
                  class="btn position-relative py-2 btn-sm text-uppercase letter-spacing-2 fw-bold btn-primary rounded-0 px-5 spinss">Submit</button>
            </div>
         </form>
      </div>
   </div>
</template>